// extracted by mini-css-extract-plugin
export default {"box":"ActionBar_box__UgXqX","icon":"ActionBar_icon__-grgu"};